import { http } from '@/core/api/';
const apiUrl = 'api/public-portal-schedule-item';

export const getInitFilter = () => {
  return http.get(`${apiUrl}/init-filters`);
};

export const getScheduleItem = (id) => {
  return http.get(`${apiUrl}/${id}`);
};

export const search = (payload) => {
  return http.get(`${apiUrl}/search`, {
    params: { ...payload },
  });
};

export const toggle = (id) => {
  return http.post(`${apiUrl}/toggle/${id}`);
};

export const save = async (params) => {
  return await http.post(`${apiUrl}/save`, params, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};